import { createInterfaceId } from "@gitlab/needle";
//#region src/user_config/types.ts
const SandboxUserConfigLoader = createInterfaceId("SandboxUserConfigLoader");
//#endregion
export { SandboxUserConfigLoader as t };

//# sourceMappingURL=types-BP6ZEIjS.mjs.map